module.exports = __webpack_public_path__ + "img/av109.ca71683c.png";